import axiosInstance from "../../../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const saleDebitNoteURL = `api/v1/sales-app/dr-cr-notes`;

//obtaining the paginated data
export const getSaleDebitNote = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleDebitNoteURL}/list?note_type=sales_debit&${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllSaleDebitNote = () => axiosInstance.get(`${saleDebitNoteURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageSaleDebitNote = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${saleDebitNoteURL}/list?note_type=sales_debit&${paginationQueryParams(rowsPerPage, search, "", number)}`
  );

export const getSaleDebitNoteAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?is_active=true`);

// get by id
export const getSaleDebitNoteById = (id) => axiosInstance.get(`${saleDebitNoteURL}/retrieve/${id}`);
// get by id
export const getSaleDebitNoteDetailsById = (id) => axiosInstance.get(`api/v1/sales-app/sales-invoice/retrieve/${id}`);

//creating function
export const createSaleDebitNote = (body) => axiosInstance.post(`${saleDebitNoteURL}/create`, body);
//updating function
export const updateSaleDebitNote = (id, body) => axiosInstance.patch(`${saleDebitNoteURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleDebitNoteURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}&note_type=sales_debit`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
